/** 空闲时预取开户分包，避免抢首屏带宽；WebView 无 requestIdleCallback 时降级 setTimeout */

export function runWhenIdle(fn: () => void, timeout = 2000) {
  const ric = (window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
  }).requestIdleCallback;
  if (typeof ric === 'function') {
    ric(() => fn(), { timeout });
  } else {
    setTimeout(fn, 300);
  }
}

/** 上传证件页示例图（按证件类型）；提前解码，减少进页后高度/滑动抖动 */
const EXP_IMAGES_BY_TYPE: Record<string, string[]> = {
  MAINLAND_CHINA: [
    '/images/open-exp1.png',
    '/images/open-exp2.png',
    '/images/open-exp3.png',
    '/images/open-exp4.png',
  ],
  HONG_KONG: [
    '/images/open-exp1-hk.png',
    '/images/open-exp2-hk.png',
    '/images/open-exp3-hk.png',
    '/images/open-exp4-hk.png',
  ],
  MACAO: [
    '/images/open-exp1-mo.png',
    '/images/open-exp2-mo.png',
    '/images/open-exp3-mo.png',
    '/images/open-exp4-mo.png',
  ],
  OTHER_REGION: [
    '/images/open-exp1-other.png',
    '/images/open-exp2-other.png',
    '/images/open-exp3-other.png',
    '/images/open-exp4-other.png',
  ],
};

const preloadedExp = new Set<string>();

export function preloadUploadLicExampleImages(idCardType?: string) {
  if (typeof Image === 'undefined') return;
  const list =
    (idCardType && EXP_IMAGES_BY_TYPE[idCardType]) ||
    EXP_IMAGES_BY_TYPE.MAINLAND_CHINA;
  for (const src of list) {
    if (preloadedExp.has(src)) continue;
    preloadedExp.add(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  }
}

/** 准备页空闲：近邻两步（选证件 + 上传证件） */
export function preloadNearInfoSteps() {
  void import('./infomations/SelectIDCard');
  void import('./infomations/UploadLic');
  // 预热 OnlineProgress 壳（内部步骤均为 lazy，不会带上 forge）
  void import('./OnlineProgress');
  runWhenIdle(() => preloadUploadLicExampleImages());
}

/** 上传证件页挂载后：资料后续页（不含签名/forge） */
export function preloadRestInfoSteps() {
  void import('./infomations/UploadBank');
  void import('./infomations/Address');
  void import('./infomations/JobStatus');
  void import('./infomations/FinancialStatus');
  void import('./infomations/InvestmentExp');
  void import('./infomations/TaxInfo');
  void import('./infomations/Others');
  void import('./infomations/ActivateEleServices');
  void import('./infomations/SelectAccount');
}

/** 资料段尾再预热风险披露（仍不预取 Signature/cert） */
export function preloadRiskSteps() {
  void import('./risk/RiskInfo');
  void import('./risk/ConfirmInfos');
  void import('./risk/ConfirmAndSign');
}
